import { useState } from 'react';
import './input.css';

const Input = (props) => {
  const [showHint, setShowHint] = useState(false);
  const { placeholder, hint, ...inputProps } = props;
  return (
    <div className="InputContainer">
      <label>{placeholder}</label>
      <input {...inputProps} />
    </div>
  );
};

export const TextArea = (props) => {
  const [showHint, setShowHint] = useState(false);
  const { placeholder, hint, ...inputProps } = props;
  return (
    <div className="InputContainer">
      <label>{placeholder}</label>
      <textarea {...inputProps} />
    </div>
  );
};

export default Input;
